import { type SendAnalyticsEvent } from '@atlassian/conversation-assistant-instrumentation/types/analytics';
import { EMPTY_CONVERSATION_ID } from '@atlassian/conversation-assistant-store/controllers/chat';
import { type Menu } from '@atlassian/conversation-assistant-store/controllers/ui-store';

type AgentSelection = {
	id: string;
	is_default: boolean;
};

type PerformAgentSelectionParams = {
	agent: AgentSelection;
	activeMenu: Menu;
	touchpointSource: string;
	isADSNavigationEnabled: boolean;
	sendAnalyticsEvent: SendAnalyticsEvent;
	setActiveMenu: (menu: Menu) => void;
	exitSpace: () => void;
	clearActiveAction?: () => void;
	setSelectedConversation: (selection: { conversationId: string; sourceAgentId: string }) => void;
	setSideNavOpen: (isOpen: boolean) => void;
};

export const performAgentSelection = ({
	agent,
	activeMenu,
	touchpointSource,
	isADSNavigationEnabled,
	sendAnalyticsEvent,
	setActiveMenu,
	exitSpace,
	clearActiveAction,
	setSelectedConversation,
	setSideNavOpen,
}: PerformAgentSelectionParams): void => {
	sendAnalyticsEvent({
		action: 'clicked',
		actionSubject: 'button',
		actionSubjectId: 'browseAgentsSelectAgentOption',
		attributes: {
			touchpointSource,
			agentId: agent.id,
			interactionSource: touchpointSource,
			isDefaultAgent: agent.is_default,
		},
	});

	if (activeMenu !== 'none') {
		setActiveMenu('none');
	}

	exitSpace();
	clearActiveAction?.();
	setSelectedConversation({
		conversationId: EMPTY_CONVERSATION_ID,
		sourceAgentId: agent.id,
	});

	if (!isADSNavigationEnabled) {
		setSideNavOpen(false);
	}
};
